export const TEXTS = {
    HEADER_TITLE: "My Cart",
    HEADER_SUBTITLE: "{0} items",
};

export const HEADER_BG_COLOR = "#fff";

export const STEAL_STORE_CART_TEST_IDS = {
    HEADER_TITLE: "header-title",
    TOTAL_ITEMS_COUNT: "total-items-count",
    CART_HEADER: "steal-store-cart-header",
};